
import { Tabs, Button } from "antd";

import AppLayout from "../../components/Layout";
import { BorrowerData } from "./BorrowerData";


const PredictiveDailer = () => {
 
 

  return (
    <AppLayout moduleName="Predictive Dialer" >

    <div>
        <BorrowerData/>
    </div>
    </AppLayout>
  );
};

export default PredictiveDailer;
